import { ROUTES } from "../../../constant/routes";
import { StyledHeroSection } from "./styles";
import BookDemoModal from "../../../components/shared/BookDemoModal";

const HeroSection = () => {
  return (
    <StyledHeroSection className="hero-content" id="resources">
      <div className="section-padding hero-grid">
        <div>
          <div className="eyebrow">
            ✦ Built for modern customer relationships
          </div>

          <h1>
            One workspace for every
            <br />
            <span className="gradient-text"> customer relationship.</span>
          </h1>

          <p>
            Communicate with customers, collaborate with your team, run video
            meetings, manage tasks, share documents and work alongside AI all
            from one secure workspace.
          </p>

          <div className="hero-actions">
            <a
              className="btn btn-primary"
              href={ROUTES.SIGNUP}
              rel="noopener noreferrer"
            >
              Start free
            </a>
            <BookDemoModal>
              <a className="btn btn-secondary">Book a demo</a>
            </BookDemoModal>
          </div>

          <div className="hero-note">
            Built for regulated industries where consumer messaging is not
            suitable including care homes, estate agents, accountants and
            solicitors.
          </div>
        </div>

        <div className="product">
          <div className="window">
            <div className="window-bar">
              <span className="dot"></span>
              <span className="dot"></span>
              <span className="dot"></span>
            </div>

            <div className="app">
              <aside className="sidebar">
                <div className="side-logo"></div>

                <div className="side-item active"></div>
                <div className="side-item"></div>
                <div className="side-item"></div>
                <div className="side-item"></div>
                <div className="side-item"></div>
              </aside>

              <div className="chat">
                <div className="chat-head">
                  <div className="person">
                    <div className="avatar"></div>

                    <div>
                      <div className="name"></div>
                      <div className="sub"></div>
                    </div>
                  </div>

                  <div
                    className="avatar"
                    style={{
                      borderRadius: "11px",
                      background: "#eee8f5",
                    }}
                  ></div>
                </div>

                <div className="messages">
                  <div className="msg">
                    <div className="msg-line"></div>
                    <div className="msg-line" style={{ width: "70%" }}></div>
                  </div>

                  <div className="msg right">
                    <div className="msg-line"></div>
                    <div className="msg-line" style={{ width: "55%" }}></div>
                  </div>

                  <div className="msg">
                    <div className="msg-line"></div>
                    <div className="msg-line" style={{ width: "82%" }}></div>
                  </div>

                  <div className="msg right" style={{ width: "58%" }}>
                    <div className="msg-line"></div>
                  </div>

                  <div className="composer"></div>
                </div>
              </div>

              <aside className="workspace">
                <div className="work-title"></div>

                <div className="work-card">
                  <div className="work-icon"></div>
                  <div className="work-line"></div>
                  <div className="work-line" style={{ width: "62%" }}></div>
                </div>

                <div className="work-card">
                  <div className="work-icon"></div>
                  <div className="work-line"></div>
                  <div className="work-line" style={{ width: "72%" }}></div>
                </div>

                <div className="work-card">
                  <div className="work-icon"></div>
                  <div className="work-line"></div>
                  <div className="work-line" style={{ width: "55%" }}></div>
                </div>
              </aside>
            </div>
          </div>

          <div className="float-card float-one">✓ Customer update shared</div>

          <div className="float-card float-two">✦ AI task created</div>
        </div>
      </div>
    </StyledHeroSection>
  );
};

export default HeroSection;
